import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { HERO_VIDEO, IMAGES } from "../../data/content";

const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative h-[90vh] md:h-screen w-full overflow-hidden flex items-end"
    >
      <img
        src={IMAGES.heroPoster}
        alt="Jaron Thames"
        className="absolute inset-0 w-full h-full object-cover object-top film-warm-strong"
      />

      {/* darkening overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-matte via-matte/55 to-matte/30" />
      <div className="absolute inset-0 bg-matte/25" />
      {/* warm golden spotlight tint */}
      <div className="absolute inset-0 bg-gradient-to-tr from-[#1a1206]/40 via-transparent to-[#3a2a12]/30 mix-blend-soft-light" />

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16 pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="eyebrow mb-4"
        >
          One Of None
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="heading text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] text-cream"
        >
          JARON THAMES
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.55 }}
          className="mt-4 max-w-md text-cream/80 text-base md:text-lg leading-relaxed"
        >
          Hooping around the world.
          <br />
          Trusting God's timing.
          <br />
          Still chasing the dream.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75 }}
          className="mt-9 flex flex-col sm:flex-row gap-4"
        >
          <button data-testid="hero-follow-btn" className="btn-primary" onClick={() => go("journey")}>
            Follow The Journey <ArrowRight size={16} />
          </button>
          <button data-testid="hero-watch-btn" className="btn-secondary" onClick={() => go("highlights")}>
            <Play size={16} /> Watch Highlights
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        className="absolute bottom-6 right-6 md:right-12 z-10 hidden md:flex items-center gap-3 text-silver/60"
      >
        <span className="uppercase tracking-[0.3em] text-[0.6rem]">Scroll</span>
        <span className="h-px w-12 bg-silver/40" />
      </motion.div>
    </section>
  );
};
